<template>
  <div class="intro flex flex-wrap w-full flex-1 p-3">
    <div class="w-full lg:w-1/3 px-3">
      <div class="bg-white h-full p-4">
        <div class="mb-5">
          <p class="intro-title lg:text-lg flex"><img src="@/assets/image/ai/quote.png" alt="">{{ $t('intro.service_features') }}</p>
          <p class="intro-content lg:text-lg">{{ $t('intro.service_features_text') }}</p>
        </div>
        <div class="mb-5">
          <p class="intro-title lg:text-lg flex"><img src="@/assets/image/ai/quote.png" alt="">{{ $t('intro.remark') }}</p>
          <p class="intro-content lg:text-lg mb-2">{{ $t('intro.remark_text') }}</p>
          <p class="intro-content lg:text-lg">{{ $t('intro.remark_text2') }}</p>
        </div>
        <div class="mb-5">
          <p class="intro-title lg:text-lg flex"><img src="@/assets/image/ai/quote.png" alt="">{{ $t('intro.disclaimer') }}</p>
          <p class="intro-content lg:text-lg" v-html="$t('intro.disclaimer_text')" @click.capture="openCleanExternalLink"></p>
        </div>
      </div>
    </div>
    <div class="illustrate w-full lg:w-2/3 lg:text-lg mt-3 lg:mt-0 px-3">
      <div class="intro-banner text-white py-4 text-lg mb-4">
        <p>{{ $t('intro.Instructions_for_use') }}</p>
      </div>
      <div class="flex flex-wrap">
        <div class="step step1 py-3 flex items-center justify-center">
          <p>{{ $t('intro.step1_title') }}</p>
        </div>
        <div class="intro-text bg-white py-3 flex-1 px-3">
          <p>{{ $t('intro.step1_text') }}</p>
        </div>
      </div>
      <div class="arrow my-2 mx-auto sm:mx-0">
        <img src="@/assets/image/ai/Arrow1.png" alt="" class="mx-auto block">
      </div>
      <div class="flex flex-wrap">
        <div class="step step2 py-3 flex items-center justify-center">
          <p>{{ $t('intro.step2_title') }}</p>
        </div>
        <div class="intro-text bg-white py-3 flex-1 px-3">
          <p>{{ $t('intro.step2_text') }}</p>
        </div>
      </div>
      <div class="arrow my-2 mx-auto sm:mx-0">
        <img src="@/assets/image/ai/Arrow2.png" alt="" class="mx-auto block">
      </div>
      <div class="flex flex-wrap">
        <div class="step step3 py-3 flex items-center justify-center">
          <p>{{ $t('intro.step3_title') }}</p>
        </div>
        <div class="intro-text bg-white py-3 flex-1 px-3">
          <p>{{ $t('intro.step3_text') }}</p>
        </div>
      </div>
      <div class="arrow my-2 mx-auto sm:mx-0">
        <img src="@/assets/image/ai/Arrow3.png" alt="" class="mx-auto block">
      </div>
      <div class="flex flex-wrap">
        <div class="step step4 py-3 flex items-center justify-center">
          <p>{{ $t('intro.step4_title') }}</p>
        </div>
        <div class="intro-text bg-white py-3 flex-1 px-3">
          <p>{{ $t('intro.step4_text') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'intro',
    metaInfo: {
      title: '使用指南'
    },
    methods: {
      openCleanExternalLink (event) {
        let target = event.target

        while (target && target !== event.currentTarget) {
          if (target.dataset && target.dataset.cleanUrl) {
            event.preventDefault()
            event.stopPropagation()
            window.open(target.dataset.cleanUrl, '_blank', 'noopener,noreferrer')
            return
          }

          target = target.parentNode
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .intro {
    min-height: calc(100vh - 108px);
    width: calc(100vh - 260px);
  }
  .intro-title {
    line-height: 2;
    color: #F30000;
    font-weight: 900;
    @media (max-width: 1023px) {
      font-size: 1.125rem;
    }
  }
  .intro-content {
    line-height: 1.8;
    color: #1A1A1A;
    font-weight: 600;
    @media (max-width: 1023px) {
      font-size: 1.125rem;
    }
  }
  .intro-banner {
    background: #0E103E;
    text-align: center;
    // margin-bottom: 2rem;
    font-weight: 700;
    background-image: url('~@/assets/image/ai/plusB.png'), url('~@/assets/image/ai/plusS.png'), url('~@/assets/image/ai/plusB.png'), url('~@/assets/image/ai/plusS.png');
    background-repeat: no-repeat;
    background-position: left 10% bottom 20%, left 5% top 20%, right 10% bottom 20%, right 5% top 20%;
    p {
      margin: 0;
    }
    @media (max-width: 1023px) {
      font-size: 1.125rem;
    }
  }
  .illustrate {
    font-weight: 600;
    .arrow {
      width: 20%;
    }
    .step {
      width: 20%;
      @media (max-width: 575px) {
        width: 100%;
      }
    }
    .step1 {
      background-color: #252F82;
      p {
        text-align: center;
        color: white;
      }
    }
    .step2 {
      background-color: #642582;
      p {
        text-align: center;
        color: white;
      }
    }
    .step3 {
      background-color: #9B128D;
      p {
        text-align: center;
        color: white;
      }
    }
    .step4 {
      background-color: #D33F2A;
      p {
        text-align: center;
        color: white;
      }
    }
    .step5 {
      background-color: #F96F34;
      p {
        text-align: center;
        color: white;
      }
    }
    .intro-text{
      text-align: center;
      border-top: 1px solid #0E103E;
      border-bottom: 1px solid #0E103E;
      p {
        text-align: left;
        margin: 0;
        @media (max-width: 1023px) {
          font-size: 1.125rem;
        }
      }
    }
  }

</style>
